module.exports = __webpack_public_path__ + "238ffa251b5d70173062d289023e7ab8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/open-book-white.png
// module id = 3700
// module chunks = 0